module.exports = __webpack_public_path__ + "static/img/kcc-logo-encn.4fe80ee1.png";